import { DefaultService } from '@/services/DefaultService';

export default class EmpresaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(file, form) {
        // Cria o formData para enviar o arquivo
        var data = new FormData();
        data.append("file", file);
        // Adiciona o objeto com os dados auxiliares do anexo.
        data.append("empresa", new Blob([JSON.stringify( form )],
        {
            type: "application/json"
        }));
        data.append("empresa", form);

        // Altera o Header para adicionar os headers necessários do multipart-data
        let requestHeader = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: data
        }

        // Remove o content-type do header para forçar o navegador a inseri-los novamente, gerando corretamente o content-type necessário.
        delete requestHeader.headers["Content-Type"];

		return this._http.post(`${this._env}/vendas/empresa`, data, requestHeader).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    saveTributacaoVendas(form) {
		return this._http.post(`${this._env}/vendas/empresa/tributacao`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveTributacaoPromotor(form) {
		return this._http.post(`${this._env}/promotor/empresa/tributacao`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveTributacaoAgro(form) {
		return this._http.post(`${this._env}/agro/empresa/tributacao`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveParametrizacao(form, contexto = "ven") {
		return this._http.post(`${this._env}/${contexto}/empresa/parametrizacao`, form, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/empresa/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllVendas(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/empresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findAllPromotor(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/promotor/empresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findAllAgro(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/empresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findAllDespesas(column, order, page, limit, situacao, ...params) {
		return this._http.get( encodeURI(`${this._env}/des/empresa.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

    findAllOld(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/empresaold.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findList(query) {
        return this._http.get(encodeURI(`${this._env}/vendas/empresa/list.json?param=${query}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findEmpresaById(id, ...param) {
        return this._http.get(`${this._env}/vendas/empresa/listbyuser.json?id=${id}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findEmpresaAssByIdUsuario(id) {
        return this._http.get(`${this._env}/vendas/empresa/listbyuserass.json?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getInfoByCNPJ(uf, cnpj) {
        return this._http.get(`${this._env}/general/cnpj.json?uf=${uf}&cnpj=${cnpj}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getInfoByCEP(cep, token) {
        return this._http.post(`${this._env}/consultacep/${cep}`, {token: token},
            {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, HEAD, OPTIONS"
            }
        ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveBlindagemVendas(empresa) {
		return this._http.post(`${this._env}/vendas/empresa/blindagem`, empresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveBlindagemAgro(empresa) {
		return this._http.post(`${this._env}/agro/empresa/blindagem`, empresa, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    //@71156 - busca as empresas para aparecerem no filtro de empresa, na listagem de Agro visita
    findAllCombo(params) {
        return this.findAllComboSituacao(3, params);
    }
    // filtra situação pelo replicapda
    findAllComboSituacao(situacao = 3, ...params) {
		return this._http.get(encodeURI(`${this._env}/getcombo/empresa.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
		}, err => {
            this.handleError(err);
		});
	}

    findEmpresasNotInSaldoProduto(idproduto, search, idempresa) {
        return this._http.get(`${this._env}/sales/comboempresabysaldoproduto.json?idproduto=${idproduto}&search=${search}&idempresa=${idempresa}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    loadNameVendas(id) {
		return this._http.get(`${this._env}/vendas/empresa/name?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadNamePromotor(id) {
		return this._http.get(`${this._env}/promotor/empresa/name?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadNameAgro(id) {
		return this._http.get(`${this._env}/agro/empresa/name?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    loadNameDespesas(id) {
		return this._http.get(`${this._env}/des/empresa/name?id=${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}